var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "stats"
  }, [_vm._m(0), _c('article', {
    staticClass: "meta"
  }, [_c('p', {
    staticClass: "label"
  }, [_vm._v(" Validators "), _c('TooltipMeta', {
    attrs: {
      "content": "Total number of nodes validating transactions on Avalanche",
      "color": '#2196f3'
    }
  })], 1), _c('div', [_vm.subnetsLoaded ? _c('p', {
    staticClass: "meta_val"
  }, [_vm._v(" " + _vm._s(_vm.totalValidatorsCount.toLocaleString()) + " ")]) : _c('v-progress-circular', {
    key: "1",
    attrs: {
      "size": 16,
      "width": 2,
      "color": "#E84970",
      "indeterminate": ""
    }
  })], 1)]), _c('article', {
    staticClass: "meta"
  }, [_c('p', {
    staticClass: "label"
  }, [_vm._v(" Total Staked "), _c('TooltipMeta', {
    attrs: {
      "content": "Total value of AVAX locked to secure Avalanche",
      "color": '#2196f3'
    }
  })], 1), _c('div', [_vm.subnetsLoaded ? _c('p', {
    staticClass: "meta_val"
  }, [_vm._v(" " + _vm._s(_vm.totalStake) + " "), _c('span', {
    staticClass: "unit"
  }, [_vm._v("AVAX")])]) : _c('v-progress-circular', {
    key: "1",
    attrs: {
      "size": 16,
      "width": 2,
      "color": "#E84970",
      "indeterminate": ""
    }
  })], 1)]), _c('article', {
    staticClass: "meta"
  }, [_c('p', {
    staticClass: "label"
  }, [_vm._v(" Staking Ratio "), _c('TooltipMeta', {
    attrs: {
      "content": "Percentage of AVAX locked to secure Avalanche out of total AVAX supply",
      "color": '#2196f3'
    }
  })], 1), _c('div', [_vm.subnetsLoaded ? _c('p', {
    staticClass: "meta_val"
  }, [_vm._v(" " + _vm._s(_vm.percentStaked) + "% ")]) : _c('v-progress-circular', {
    key: "1",
    attrs: {
      "size": 16,
      "width": 2,
      "color": "#E84970",
      "indeterminate": ""
    }
  })], 1)]), _c('article', {
    staticClass: "meta"
  }, [_c('p', {
    staticClass: "label"
  }, [_vm._v("Annual Staking Reward")]), _c('div', [_vm.subnetsLoaded ? _c('p', {
    staticClass: "meta_val"
  }, [_vm._v(" " + _vm._s(_vm.annualStakingRewardPercentage) + " ")]) : _c('v-progress-circular', {
    key: "1",
    attrs: {
      "size": 16,
      "width": 2,
      "color": "#E84970",
      "indeterminate": ""
    }
  })], 1)])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "header"
  }, [_c('h4', {
    staticClass: "meta_title"
  }, [_vm._v("Staking Stats")]), _c('p', {
    staticClass: "subtitle"
  })]);
}]

export { render, staticRenderFns }